import React, { useRef, useState } from 'react'
import { useFormik } from 'formik';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import Select from 'react-select';
import * as Yup from 'yup';
import { Table } from "antd";
// import { adminMainUrl } from '../../Config';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Accordion from 'react-bootstrap/Accordion';
import { useNavigate, Link } from 'react-router-dom'
// import { adminMainUrl } from '../../../../Config';
const AddMaster = ({ show, handleClose, onSuccess }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const closeButtonRef = useRef(null);
    const ApplicableOption = [{ value: 'Non-Hazardous', label: 'Non-Hazardous' },
    { value: 'Hazardous', label: 'Hazardous' },
    { value: 'Perishable', label: 'Perishable' },]
    const validationSchema = Yup.object({
        name: Yup.string().required('Name is required'),
        SCAC: Yup.string().required('SCAC is required'),
        Alias: Yup.string().required('Alias is required'),
        AccountNo: Yup.string().required('Account No is required'),
        HomePageUrl: Yup.string().required('HomePage Url is required'),
        TrackingUrl: Yup.string().required('Tracking Url is required'),
        BlFormat: Yup.string().required('BL Format is required'),
    });

    // Initialize Formik
    const formik = useFormik({
        initialValues: {
            name: '', // Initial value for the RequiredService type
            SCAC: "",
            Alias: "",
            AccountNo: "",
            HomePageUrl: "",
            TrackingUrl: "",
            applicableFor: '',
            BlFormat: ""
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            handleClose()
            formik.resetForm();
            setIsSubmitting(true);
            // try {
            //     const response = await fetch(`${adminMainUrl}/api/department/create`, {
            //         method: 'POST',
            //         headers: {
            //             'Content-Type': 'application/json',
            //             'auth-token': Cookies.get('token'), // Assuming token is stored in cookies
            //         },
            //         body: JSON.stringify(values),
            //     });

            //     const data = await response.json();

            //     if (response.ok) {
            //         // closeButtonRef.current.click();
            //         if (onSuccess) onSuccess();
            //         toast.success(data?.msg);
            //         handleClose()
            //         formik.resetForm();
            //     } else {
            //         toast.error(data?.msg);
            //         // Handle errors from the server
            //         console.error('Error creating RequiredService Type:', data.message);
            //     }
            // } catch (error) {
            //     console.error('Network error:', error);
            // }
            // finally {
            //     setIsSubmitting(false); // Stop the spinner
            // }
        },
    });

    return (
        <Offcanvas show={show} onHide={handleClose} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Add Commodity</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Name <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id="name"
                                        name="name"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.name}
                                    />
                                    {formik.touched.name && formik.errors.name ? (
                                        <div className="error">{formik.errors.name}</div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Description <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id="SCAC"
                                        name="SCAC"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.SCAC}
                                    />
                                    {formik.touched.SCAC && formik.errors.SCAC ? (
                                        <div className="error">{formik.errors.SCAC}</div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    IATA Code <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <input
                                        type="text"
                                        className="form-control form-control-sm w-100"
                                        id=" IATACode"
                                        name=" IATACode"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.IATACode}
                                    />
                                    {formik.touched.IATACode && formik.errors.IATACode ? (
                                        <div className="error">{formik.errors.IATACode}</div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="mb-2 ">
                                <label htmlFor="name" className="form-label ">
                                    Nature <span style={{ color: 'red' }}>*</span>
                                </label>
                                <div className='w-100'>
                                    <Select
                                        className="custom-selector"
                                        options={ApplicableOption}
                                        value={ApplicableOption.find(option => option.value === formik.values.applicableFor) || null}
                                        onChange={(selectedOption) => formik.setFieldValue("applicableFor", selectedOption.value)}
                                        onBlur={formik.handleBlur}
                                    />
                                    {formik.touched.charge_category && formik.errors.charge_category ? (
                                        <div className="error">{formik.errors.charge_category}</div>
                                    ) : null}
                                    {formik.touched.IATACode && formik.errors.IATACode ? (
                                        <div className="error">{formik.errors.IATACode}</div>
                                    ) : null}
                                </div>
                            </div>
                        </div>

                    </div>
                    {
                        formik.values.applicableFor === 'Hazardous' && <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header py-2">
                                        Hazardous
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="mb-2 ">
                                                    <label htmlFor="name" className="form-label ">
                                                        Description <span style={{ color: 'red' }}>*</span>
                                                    </label>
                                                    <div className='w-100'>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm w-100"
                                                            id="name"
                                                            name="name"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.name}
                                                        />
                                                        {formik.touched.name && formik.errors.name ? (
                                                            <div className="error">{formik.errors.name}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-2 ">
                                                    <label htmlFor="name" className="form-label ">
                                                        IMCO Class <span style={{ color: 'red' }}>*</span>
                                                    </label>
                                                    <div className='w-100'>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm w-100"
                                                            id="name"
                                                            name="name"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.name}
                                                        />
                                                        {formik.touched.name && formik.errors.name ? (
                                                            <div className="error">{formik.errors.name}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-2 ">
                                                    <label htmlFor="name" className="form-label ">
                                                        IMCO Class <span style={{ color: 'red' }}>*</span>
                                                    </label>
                                                    <div className='w-100'>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm w-100"
                                                            id="name"
                                                            name="name"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.name}
                                                        />
                                                        {formik.touched.name && formik.errors.name ? (
                                                            <div className="error">{formik.errors.name}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-2 ">
                                                    <label htmlFor="name" className="form-label ">
                                                        IMCO Page <span style={{ color: 'red' }}>*</span>
                                                    </label>
                                                    <div className='w-100'>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm w-100"
                                                            id="name"
                                                            name="name"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.name}
                                                        />
                                                        {formik.touched.name && formik.errors.name ? (
                                                            <div className="error">{formik.errors.name}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-2 ">
                                                    <label htmlFor="name" className="form-label ">
                                                        MFG No <span style={{ color: 'red' }}>*</span>
                                                    </label>
                                                    <div className='w-100'>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm w-100"
                                                            id="name"
                                                            name="name"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.name}
                                                        />
                                                        {formik.touched.name && formik.errors.name ? (
                                                            <div className="error">{formik.errors.name}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-2 ">
                                                    <label htmlFor="name" className="form-label ">
                                                        UNDG Code <span style={{ color: 'red' }}>*</span>
                                                    </label>
                                                    <div className='w-100'>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm w-100"
                                                            id="name"
                                                            name="name"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.name}
                                                        />
                                                        {formik.touched.name && formik.errors.name ? (
                                                            <div className="error">{formik.errors.name}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-2 ">
                                                    <label htmlFor="name" className="form-label ">
                                                        Flash Point <span style={{ color: 'red' }}>*</span>
                                                    </label>
                                                    <div className='w-100'>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm w-100"
                                                            id="name"
                                                            name="name"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.name}
                                                        />
                                                        {formik.touched.name && formik.errors.name ? (
                                                            <div className="error">{formik.errors.name}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-2 ">
                                                    <label htmlFor="name" className="form-label ">
                                                        IMO Code <span style={{ color: 'red' }}>*</span>
                                                    </label>
                                                    <div className='w-100'>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm w-100"
                                                            id="name"
                                                            name="name"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.name}
                                                        />
                                                        {formik.touched.name && formik.errors.name ? (
                                                            <div className="error">{formik.errors.name}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-2 ">
                                                    <label htmlFor="name" className="form-label ">
                                                        Contact Name <span style={{ color: 'red' }}>*</span>
                                                    </label>
                                                    <div className='w-100'>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm w-100"
                                                            id="name"
                                                            name="name"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.name}
                                                        />
                                                        {formik.touched.name && formik.errors.name ? (
                                                            <div className="error">{formik.errors.name}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-2 ">
                                                    <label htmlFor="name" className="form-label ">
                                                        Contact Tel No <span style={{ color: 'red' }}>*</span>
                                                    </label>
                                                    <div className='w-100'>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm w-100"
                                                            id="name"
                                                            name="name"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.name}
                                                        />
                                                        {formik.touched.name && formik.errors.name ? (
                                                            <div className="error">{formik.errors.name}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-2 ">
                                                    <label htmlFor="name" className="form-label ">
                                                        Packing Group <span style={{ color: 'red' }}>*</span>
                                                    </label>
                                                    <div className='w-100'>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm w-100"
                                                            id="name"
                                                            name="name"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.name}
                                                        />
                                                        {formik.touched.name && formik.errors.name ? (
                                                            <div className="error">{formik.errors.name}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-2 ">
                                                    <label htmlFor="name" className="form-label ">
                                                        Sub Classes <span style={{ color: 'red' }}>*</span>
                                                    </label>
                                                    <div className='w-100'>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm w-100"
                                                            id="name"
                                                            name="name"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.name}
                                                        />
                                                        {formik.touched.name && formik.errors.name ? (
                                                            <div className="error">{formik.errors.name}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-2 ">
                                                    <label htmlFor="name" className="form-label ">
                                                        EMS No <span style={{ color: 'red' }}>*</span>
                                                    </label>
                                                    <div className='w-100'>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm w-100"
                                                            id="name"
                                                            name="name"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.name}
                                                        />
                                                        {formik.touched.name && formik.errors.name ? (
                                                            <div className="error">{formik.errors.name}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="mb-2 ">
                                                    <label htmlFor="name" className="form-label ">
                                                        Marine Pollutant <span style={{ color: 'red' }}>*</span>
                                                    </label>
                                                    <div className='w-100'>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm w-100"
                                                            id="name"
                                                            name="name"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.name}
                                                        />
                                                        {formik.touched.name && formik.errors.name ? (
                                                            <div className="error">{formik.errors.name}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    <div className="d-flex justify-content-end gap-2 mt-2">
                        {/* <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Submit"}
                        </button> */}
                        <button className="btn btn-primary text-xs" type="submit" onClick={handleClose}>
                            Submit
                        </button>
                        <button className="btn btn-primary text-xs" type="submit" onClick={handleClose}>
                            Save & Close
                        </button>
                        <button className="btn btn-primary text-xs" type="submit" onClick={handleClose}>
                            Save & New
                        </button>
                        <button className="btn btn-light text-xs" type="submit" onClick={handleClose}>
                            Close
                        </button>
                    </div>

                </form>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default AddMaster